import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwj324Api, QueryParams, ResultRow } from '../../../services/pwj324Api';

export function usePWJ324Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ResultRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwj324Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, queried, noData, runQuery, reset };
}
